import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr max-content',
	gap: 16,
	alignItems: 'center',
}));

export const ProfileIconCircle = styled('div')(({ theme }) => ({
	width: 48,
	height: 48,
	borderRadius: 200,
	background: theme.palette.neutral[0],
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	border: `1px solid ${theme.palette.primary.main}`,
	color: theme.palette.primary.main,
}));
